<template>
  <div class="col m3 grey lighten-5 sidenavMinhasSimulacoes">
    <br />
    <div class="input-field col s12">
      <i class="material-icons prefix">search</i>
      <input type="text" id="autocomplete-input" class="autocomplete" v-model="searchTerm" @change="enviaTermo"/>
      <label for="autocomplete-input">Procurar nos registros</label>
    </div>
    <div class="collection">
      <a
        href="#!"
        class="collection-item active"
        v-if="visualizacaoSection == 'simulacoes'"
        @click="AlteraSection('simulacoes')"
      >
        <i class="material-icons left">scatter_plot</i> Simulações
      </a>
      <a href="#!" class="collection-item" v-else @click="AlteraSection('simulacoes')">
        <i class="material-icons left">scatter_plot</i> Simulações
      </a>

      <a
        href="#!"
        class="collection-item active"
        v-if="visualizacaoSection == 'arquivados'"
        @click="AlteraSection('arquivados')"
      >
        <i class="material-icons left">archive</i> Arquivados
      </a>
      <a href="#!" class="collection-item" v-else @click="AlteraSection('arquivados')">
        <i class="material-icons left">archive</i> Arquivados
      </a>
    </div>
    <a href="/home/nova-simulacao" class="collection-item btn btn-large left-align col s12">
      <i class="material-icons right">add</i> Nova Simulação
    </a>
  </div>
</template>
<script>
export default {
  name: "SideNavMinhasSimulacoes",
  data(){
    return{
      searchTerm:''
    }
  },
  props: {
    visualizacaoSection: String
  },
  methods: {
    AlteraSection: function(act) {
      this.visualizacaoSection = act;
      this.$emit("AlteraSectionClick", {
        section: this.visualizacaoSection
      });
    },
    enviaTermo:function(){
      this.$emit('Pesquisar', {
        termo:this.searchTerm
      });
    }
  }
};
</script>